var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 13C26 20.1797 20.1797 26 13 26H4.82857C4.4183 26 4.08571 25.6674 4.08571 25.2571C4.08571 24.8469 4.4183 24.5143 4.82857 24.5143H5.60857C5.81371 24.5143 5.98 24.348 5.98 24.1429C5.98 24.025 5.92936 23.9113 5.83949 23.8519C2.32094 21.5256 0 17.5338 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13ZM19.3262 9.14048C18.0835 6.89728 14.9502 4.79079 10.9399 5.85631C7.38144 6.80178 5.61559 10.2874 5.6156 11.9723C5.61562 14.0428 8.53407 14.7184 11.8666 14.438C15.5313 14.1297 17.2516 13.2351 20.0758 11.048C16.3777 13.0425 14.1885 13.5415 11.0497 13.3281C9.34599 13.2122 6.96486 12.6237 7.54533 9.99823C7.89932 8.39719 9.72157 6.68442 12.1676 6.24148C16.0423 5.53983 18.6306 8.28652 19.3262 9.14048ZM20.2337 11.4719C20.7666 13.4282 20.199 15.8717 18.6309 17.7679C16.4941 20.3518 13.1202 20.9537 10.3774 20.0045C13.2058 19.7396 15.0689 18.8094 16.7416 17.3859C16.5346 17.5382 16.3199 17.6836 16.0977 17.8213C13.019 19.7289 8.91213 19.6875 6.7351 17.1534C8.80754 17.6949 10.4689 17.8506 12.1657 17.4861C9.34423 17.6567 6.79769 16.4746 5.5715 14.3584C7.14548 15.5143 10.7358 16.3406 14.4279 15.2269C16.8725 14.4895 18.8877 13.1498 20.193 11.5642L20.1886 11.5798C20.2023 11.5539 20.2158 11.528 20.2291 11.5021L20.2337 11.4719Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app-logo.30092b27e492ed4764362da1bc8ecc57.svg";
export { ForwardRef as ReactComponent };